import React from "react";
import { Platform, TouchableOpacity, TouchableNativeFeedback } from "react-native";

export const TouchableItem = Platform.OS === "ios" ? TouchableOpacity : TouchableNativeFeedback;
